module.exports = __webpack_public_path__ + "img/logo-traced.6a032d0c.jpg";